import { useRef, useEffect, useState } from 'react';

export const useScrollReveal = (threshold = 0.15) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Safety net: force visible after 800ms if observer never fires
    const safetyTimer = setTimeout(() => {
      setIsVisible(true);
    }, 800);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          clearTimeout(safetyTimer);
          if (ref.current) observer.unobserve(ref.current);
        }
      },
      { threshold }
    );
    const current = ref.current;
    if (current) observer.observe(current);
    return () => {
      clearTimeout(safetyTimer);
      if (current) observer.unobserve(current);
    };
  }, [threshold]);

  return { ref, isVisible };
};